import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles({
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
  logo: {
    color: '#f50057',
    fontWeight: 900,
    fontSize: '1.5rem',
    left: '1em',
    top: '1em',
    position: 'absolute',
  },
  title: {
    fontSize: '7rem',
    fontWeight: '900',
    letterSpacing: '1.5',
  },
  subtitle: {
    fontSize: '2rem',
    fontWeight: '900',
    letterSpacing: '1.5',
  },
});

export default function PageNotFound() {
  const classes = useStyles();
  return (
    <>
      <Helmet>
        <title>404 - Page not found</title>
      </Helmet>

      <div className={classes.container}>
        <Typography color='secondary' className={classes.logo}>
          Chatty.
        </Typography>
        <Typography color='secondary' className={classes.title} variant='h1'>
          404
        </Typography>
        <Typography color='textSecondary' className={classes.subtitle}>
          Page Not Found!
        </Typography>
      </div>
    </>
  );
}
